const phoneToSendVerificationCodeParams = (phone: string, countryCode: string) => {
  return {
    resource: {
      resourceType: 'TelecomVerification',
      workflow: {
        telecom: {
          system: 'phone',
          value: countryCode + phone,
          // countryCode: countryCode,
        },
      },
    },
  };
};

export default phoneToSendVerificationCodeParams;
